import React from 'react';

interface IIfProps extends React.HTMLAttributes<HTMLDivElement> {
    show: boolean;
    children: JSX.Element | null | React.ReactNode | React.ReactNode[];
}

export const IfShow = (props: IIfProps) => {
    const { show, style = {}, children, ...rest } = props;
    return (
        <div
            style={{
                ...style,
                display: show ? 'block' : 'none',
            }}
            {...rest}
        >
            {children}
        </div>
    );
};
